const VARIABLES = {
  IZI_CORE_VARIABLE_ORIGIN: process.env.IZI_CORE_VARIABLE_ORIGIN,
  REACT_APP_SOCKET_URL: process.env.REACT_APP_SOCKET_URL,
  REACT_APP_CHAT_SERVICE_ORIGIN: process.env.REACT_APP_CHAT_SERVICE_ORIGIN,
  REACT_APP_CDN_URL: process.env.REACT_APP_CDN_URL,
};

export const getEnv = (name) => VARIABLES[name];
